import { createQueryKey, getFetchedDataPayload } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
export const getScreeningDatesForQuery = (query) => {
    const queryKey = createQueryKey(query);
    return getFetchedDataPayload(browsingDomainStore.data.filmScreeningDatesForQuery[queryKey]);
};
//# sourceMappingURL=get-screening-dates-for-query.js.map